import { type Lang } from "@/lib/i18n";

export const BrandName = ({ lang }: { lang: Lang }) => lang === 'zh'
  ? <span className="text-xl md:text-2xl font-black tracking-normal text-black whitespace-nowrap" style={{ fontFamily: '"Noto Sans SC", sans-serif' }}>爆爆精灵</span>
  : <span className="text-xl md:text-2xl font-bold tracking-[0.02em] text-black uppercase font-landing-display whitespace-nowrap">POPWIZ</span>;

export const BrandNameSm = ({ lang }: { lang: Lang }) => lang === 'zh'
  ? <span className="text-xl font-black tracking-normal text-black" style={{ fontFamily: '"Noto Sans SC", sans-serif' }}>爆爆精灵</span>
  : <span className="text-xl font-bold tracking-[0.02em] text-black uppercase font-landing-display">POPWIZ</span>;
